import { FunctionComponent, useEffect, useContext, useCallback } from "react"
import { useHistory } from "react-router-dom"
import SummaryOptions from "components/Summary/SummaryOptions"
import IPage from "interfaces/IPage"
import { IconSpinner, IconBsHammer, IconTruck } from "theme/common/Icon.styled"
import { useContractor } from "hooks"
import { AuthContext } from "context/context/AuthContext"
import { EShippinggroupStatus } from "enums/shippinggroupEmun"
import { ContractorMenuItem } from "interfaces/IContractor"
import ErrorHandler from "components/Commons/Error/ErrorHandler"
import { GlobalContext } from "context/context/GlobalContext"
import Multiclient from "components/Core/Multiclient"
import { ISearchResults } from "interfaces/ISearchResults"

const ContractorDashboardScreen: FunctionComponent<IPage> = (props: any) => {
  const {
    state: { user },
  } = useContext(AuthContext)

  const { errorHander } = useContext(GlobalContext)

  const history = useHistory()

  const {
    summaryMenuOrder,
    loading,
    getSources,
    getCTOChannels,
    loadContractorData
  } = useContractor()

  const getSummaryMenuOrder = (): ContractorMenuItem[] => [
    {
      title: "Bandeja de recepción",
      path: "/contractor/reception",
      icon: <IconTruck />,
      status: EShippinggroupStatus.transit,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType : "TR",
          "custom.infoCTO.orderType" : "Recepcion",
          "currentStatus.tag":["IN_TRANSIT", "DELIVERED"],
          channel: getCTOChannels(),
          "target.source.id": user?.allSources ? undefined : getSources() || [],
        }
      }
    },
    {
      title: "Bandeja de instalaciones",
      path: "/contractor/installation",
      icon: <IconBsHammer />,
      status: EShippinggroupStatus.transit,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType : "TR",
          "custom.infoCTO.orderType" : "Instalacion",
          "currentStatus.tag":["AWAITING_STORE_CONFIRMATION", "DELIVERED"],
          channel: getCTOChannels(),
          "source.id": user?.allSources ? undefined : getSources() || [],
        }
      }
    }
  ]

  const handleClickSearch = useCallback(
    ({ query, optionFilter }: ISearchResults) => {
      if (query) history.push(`/contractor/search/${query}/${optionFilter}`)
    },
    [history],
  )

  useEffect(() => {
    const cardItems = getSummaryMenuOrder()
    loadContractorData(cardItems)
  },
  //eslint-disable-next-line
  [user])

  return (
    <>
      {errorHander?.state?.hasError ? (
        <ErrorHandler 
          code={errorHander.state.code} 
          message={errorHander.state.message || "Ha ocurrido un error inesperado"} 
        />
      ) : loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '2rem', gap: '1rem' }}>
          <IconSpinner variant="big" />
          <p style={{ margin: 0, fontSize: '1.1rem', color: '#666', textAlign: 'center' }}>
            Cargando información de bandejas...
          </p>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#999', textAlign: 'center' }}>
            Obteniendo conteos de órdenes...
          </p>
        </div>
      ) : (
        <>
          <Multiclient
            path_override="overrides/theme/wom/base/components/SearchForm/SearchForm"
            onClickSearch={handleClickSearch}
          />
          {summaryMenuOrder && <SummaryOptions summaryOptions={summaryMenuOrder as any} contractor={true} grid={false} />}
        </>
      )}
    </>
  )
}

export default ContractorDashboardScreen
